export const CHOSABLE_ROLES = [`Founder`, `Advisor`, `Investor`, `CFO`, `CEO`, `Manager`, `Other`] as const

export type ChosableRole = (typeof CHOSABLE_ROLES)[number]
